// ------------------
// imports
// ------------------

import Vue from 'vue'
import Router from 'vue-router'
import Popup from '@/common/modules/popup'
import routes from '@/common/configs/routes'


// ------------------
// Setup
// ------------------

Vue.use(Router);


// ------------------
// Config
// ------------------

const router = new Router({
    routes,
    mode: 'history',
});


// ------------------
// Guards
// ------------------

router.beforeEach((to, from, next) => {
    Popup.isActive && Popup.clear(); // hide popup
    next();
});


// ------------------
// Export
// ------------------

export default router;
